import CreateWindow from "../puzzleWindow";

import { html, render } from "lit-html";
import { userChoiceTracker } from "../../helpers/userChoiceTracker";
import { computerScreens } from "~src/helpers/computerScreens";
import "./facebookTemplate.css";
import { tips } from "~src/tips/index.js";
import {exitButtonPosition} from "../../helpers/exitButtonPosition"
import { iOSallowScroll } from "../../helpers/iOSHacks";
import { pickText } from "../../textcontents";

/* function recreateNode(el, withChildren) {
  if (withChildren) {
    el.parentNode.replaceChild(el.cloneNode(true), el);
  } else {
    var newEl = el.cloneNode(false);
    while (el.hasChildNodes()) newEl.appendChild(el.firstChild);
    el.parentNode.replaceChild(newEl, el);
  }
} */

let scrollHelper;


let createInitialState = (puzzleCode, exit) => ({
  visible: false,
  clickedPosts: [],
  currentChoice: {},
  closePuzzle: exit,
  wrongAnswerDetected: false,
  puzzleCode: puzzleCode,
  currentHeader: "",
  currentModalData: { code: "xx", fake: "false" },
});

let State;

const post = (
  {
    name,
    time,
    message,
    linkPic,
    linkUrl,
    linkHeader,
    linkDesc,
    profilePic,
    fake,
    code,
  },
  index,
  picked,
  puzzleCode,
  renderFacebook
) => {
  const callback = (header) => {

    window.scene.getSoundByName("generalComputerSound")?.play();
    State.currentModalData = { code: code, fake: fake };
    State.visible = true;
    State.currentChoice = index;
    State.currentHeader = header;

    userChoiceTracker.saveState(puzzleCode, State);
    renderFacebook();
  };

  const postAlreadyClicked = State.clickedPosts.indexOf(index) > -1;
  console.log(linkHeader)
  return html`
    <div class="facebookPost">
      <div class="fb-poster">
        <div><img src=${profilePic} /></div>
        <div>
          <div class="facebookNimi">${name}</div>
          <div class="facebookAika">${time}</div>
        </div>
      </div>
      <div class="postaus">${message ? message : ""}</div>
      <div class="linkki">
        <div class="linkkikuva"><img src=${linkPic} /></div>
        <div class="linkkitekstit">
          <div class="linkkiurli">${linkUrl}</div>
          <div class="linkkiotsikko">${linkHeader}</div>
          <div class="linkkiingressi">${linkDesc}</div>
        </div>
      </div>

      <div
        class="facebookMeta ${postAlreadyClicked ? "clicked" : ""}"
        data-id="${index}"
        data-code="${code}"
        @click=${() => (postAlreadyClicked ? null : callback(linkHeader))}
        data-fake="${fake ? "true" : "false"}"
      >
        <div>
          <div class="ilmoita"><img src="${window.pakopeliPublicAssetUrl}img/facebook/ilmoita.png" /></div>
          <div>${postAlreadyClicked ? pickText("facebook", "cta_button") : pickText("facebook", "cta_pressed_button")}</div>
        </div>
      </div>
    </div>
  `;
};
/*       <div
      class="ilmoita-container"
      @click=${() => callback(linkHeader)}
      >
      <div>
        <div class="ilmoita"   > ${!picked ? html`<img src="${window.pakopeliPublicAssetUrl}img/facebook/ilmoita.png" />` : ``}</div>
        <div>${picked? `Ilmoitettu` : "Ilmoita fakenews"}</div>
      </div>
      </div> */

let renderFunction;

const Modal = () => {
  if(scrollHelper) {
    scrollHelper.scrollTo(0,0)
  } else {
  document
    .getElementById("parentFacebookWrapper")
    .scrollTo({ top: 0, behavior: "smooth" });
  }

  const callback = () => {
    
window.scene.getSoundByName("generalComputerSound")?.play();
    if(scrollHelper) {
      scrollHelper.scrollTo(0,0)
    } else {
    document
      .getElementById("parentFacebookWrapper")
      .scrollTo({ top: 0, behavior: "smooth" });
    }
    const puzzleCode = State.puzzleCode;
    const fake = State.currentModalData.fake;
    userChoiceTracker.processAnswer(puzzleCode, fake); // saves whether the answer is true to userChoiceTracker, which is used to track player's progress in the game
    State.clickedPosts.push(State.currentChoice); // saves the info that this piece of news is selected
    userChoiceTracker.saveState(puzzleCode, State); // stores the state
    tips.solveBunkerComputer.clear();
    if (!fake) {
      State.wrongAnswerDetected = true;
      tips.bunkerComputerWrong.setTime(15, {override: true});
    }
    State.visible = false;
    if (fake) {
      State.closePuzzle();

      computerScreens.bunker.lock();
      computerScreens.warehouse.open();
    } else renderFunction();
  };

  return html`
    <div class="facebookMessage modal">
      <div class="window">
        <div class="linkkiotsikko">
        ${pickText("facebook", "messageHeader")}
        </div>
        <p>
        ${pickText("facebook", "message")}
        </p>
        <p style="font-weight: 600">${State.currentHeader}</p>
        <div class="messageNapit">
          <div
            id="oikeavastaus"
            @click=${callback}
            class="facebookButton peliin facebookiin"
          >
        ${pickText("facebook", "confirm_button")}
          </div>
          <div
            class="facebookButton facebookiin"
            style="background: "
            @click="${() => {
              window.scene.getSoundByName("generalComputerSound")?.play();
              State.visible = false;

              renderFunction();
            }}"
          >
        ${pickText("facebook", "cancel_button")}
          </div>
        </div>
      </div>
    </div>
  `;
};

const FlatPuzzle = function (posts, puzzleCode) {
  console.log(posts)
  const renderFacebook = () => {
    // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
    const modal = document.getElementById("modal-content");
    const { element, exit } = CreateWindow({
      exitCallback: () => {
        if (State.clickedPosts.length === 0) {
          tips.solveBunkerComputer.setTime(5, {override: true});
        } else if (userChoiceTracker.retrieve()[puzzleCode]) {
          // correct answer exit
          tips.bunkerComputerWrong.clear();
          tips.solveBunkerComputer.clear();
          tips.warehouseComputer.setTime(40);

        } else {
          tips.bunkerComputerWrong.setTime(0, {override: true});
        }
      },
    });
    const previousState = userChoiceTracker.retrievePreviousState(puzzleCode);
    State = previousState
      ? previousState
      : createInitialState(puzzleCode, exit);
    render(markup(), element);
  };

  const markup = () => html`
    <!--============== FACEBOOK ==================-->x
    <div id="parentFacebookWrapper">
      <div id="facebookNavi">
        <div class="vasen">
          <div class="facebookSearch">
            <div>Haku</div>
            <div><i class="search"></i></div>
          </div>
        <div><i class="logo"></i></div>
        </div>
        <div class="oikea">
          <div class="eka"><span>Etusivu</span></div>
          <div><span>Luo</span></div>
          <div><i class="kp"></i></div>
          <div><i class="msg"></i></div>
          <div><i class="ntf"></i></div>
        </div>
      </div>
      <div id="facebookContentWrapper">
        <div id="facebookSidebar">
          <div>
            <div><i class="uutiset"></i></div>
            <div>Uutiset</div>
          </div>
          <div>
            <div><i class="messenger"></i></div>
            <div>Messenger</div>
          </div>
          <div>
            <div><i class="watch"></i></div>
            <div>Watch</div>
          </div>
          <div>
            <div><i class="marketplace"></i></div>
            <div>Marketplace</div>
          </div>
          <div>
            <div><i class="tapahtumat"></i></div>
            <div>Tapahtumat</div>
          </div>
          <div>
            <div><i class="sivut"></i></div>
            <div>Sivut</div>
          </div>
          <div>
            <div><i class="ryhmat"></i></div>
            <div>Ryhmät</div>
          </div>
          <div>
            <div><i class="muistot"></i></div>
            <div>Muistot</div>
          </div>
        </div>
        <div id="facebookContent">
          ${State.visible ? Modal() : null}
          ${posts.map((e, index) => {
            const clicked = State.clickedPosts.indexOf(index) > -1;
            const picked = State.currentChoice === index;
            return post(e, index, picked, puzzleCode, renderFacebook);
          })}
        </div>
      </div>
    </div>
  `;
  renderFacebook();

  tips.solveBunkerComputer.setTime(30);
  renderFunction = renderFacebook;
  scrollHelper = iOSallowScroll("#parentFacebookWrapper")
  
  exitButtonPosition();
};

export default FlatPuzzle;
